import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getCompanyUser = createAsyncThunk(
  "Issue/getCompanyUser",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/user`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: data && data,
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCompanyUser_id = createAsyncThunk(
  "Issue/getCompanyUser_id",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/user/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddCompanyUser = createAsyncThunk(
  "Issue/AddCompanyUser",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/user`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateCompanyUser = createAsyncThunk(
  "Issue/updateCompanyUser",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/user/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const deleteCompanyUser = createAsyncThunk(
  "Issue/deleteCompanyUser",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/company/user/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const getAgency = createAsyncThunk(
  "Issue/getAgency",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/agency`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: {
            user_id: id,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddAgency = createAsyncThunk(
  "Issue/AddAgency",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/agency`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateAgency = createAsyncThunk(
  "Issue/updateAgency",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/agency/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const deleteAgency = createAsyncThunk(
  "Issue/deleteAgency",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/agency/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const GetIssue = createAsyncThunk(
  "Issue/GetIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/issues/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddIssue = createAsyncThunk(
  "Issue/AddIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/issues`, data, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateIssue = createAsyncThunk(
  "Issue/UpdateIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issues/${data.issue.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const DeleteIssue = createAsyncThunk(
  "Issue/DeleteIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issues/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const GetAllComapnyIssue = createAsyncThunk(
  "Issue/GetAllComapnyIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/issues`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: {
            is_company: 1,
            search: data && data?.search,
            search_by: data && data?.search_by,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddAllComapnyIssue = createAsyncThunk(
  "Issue/AddAllComapnyIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/issues`, data, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const UpdateAllComapnyIssue = createAsyncThunk(
  "Issue/UpdateAllComapnyIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issues/${data.issue.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const DeleteAllComapnyIssue = createAsyncThunk(
  "Issue/DeleteAllComapnyIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issues/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
// opponents
export const GetAllOpponents = createAsyncThunk(
  "Issue/GetAllOpponents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue/opponents`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
            params: {
              issue_id: id,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddIssueOpponents = createAsyncThunk(
  "Issue/AddIssueOpponents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue/opponents`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const UpdateIssueOpponents = createAsyncThunk(
  "Issue/UpdateIssueOpponents",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue/opponents/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteIssueOpponents = createAsyncThunk(
  "Issue/DeleteIssueOpponents",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue/opponents/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueManagement = createAsyncThunk(
  "Issue/getIssueManagement",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_managements`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
            params: {
              issue_id: id,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueManagement = createAsyncThunk(
  "Issue/AddIssueManagement",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_managements`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateIssueManagement = createAsyncThunk(
  "Issue/updateIssueManagement",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_managements/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteIssueManagement = createAsyncThunk(
  "Issue/DeleteIssueManagement",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_managements/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueDocument = createAsyncThunk(
  "Issue/getIssueDocument",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_documents`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
            params: {
              issue_id: id,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueDocument = createAsyncThunk(
  "Issue/AddIssueDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_documents`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateIssueDocument = createAsyncThunk(
  "Issue/updateIssueDocument",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_documents/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteIssueDocument = createAsyncThunk(
  "Issue/DeleteIssueDocument",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_documents/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getIssueTasks = createAsyncThunk(
  "Issue/getIssueTasks",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/tasks`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: {
            issue_id: id,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddIssueTasks = createAsyncThunk(
  "Issue/AddIssueTasks",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/company/tasks`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateIssueTasks = createAsyncThunk(
  "Issue/updateIssueTasks",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/tasks/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteIssueTasks = createAsyncThunk(
  "Issue/DeleteIssueTasks",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(`${process.env.REACT_APP_BACKEND_API}api/company/tasks/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getImplementationIssue = createAsyncThunk(
  "Issue/getImplementationIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_implementations`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
            params: {
              issue_id: id,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddImplementationIssue = createAsyncThunk(
  "Issue/AddImplementationIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_implementations`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateImplementationIssue = createAsyncThunk(
  "Issue/updateImplementationIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_implementations/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteImplementationIssue = createAsyncThunk(
  "Issue/DeleteImplementationIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/issue_implementations/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const AddCreateVerdict = createAsyncThunk(
  "Issue/AddCreateVerdict",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/issues/create/verdict`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getSessionsIssue = createAsyncThunk(
  "Issue/getSessionsIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/sessions`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: {
            issue_id: id,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const AddSessionsIssue = createAsyncThunk(
  "Issue/AddSessionsIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/sessions`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const updateSessionsIssue = createAsyncThunk(
  "Issue/updateSessionsIssue",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/sessions/${data.id}/update`,
          data.data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
export const DeleteSessionsIssue = createAsyncThunk(
  "Issue/DeleteSessionsIssue",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .delete(
          `${process.env.REACT_APP_BACKEND_API}api/company/sessions/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const getCompanyTasks = createAsyncThunk(
  "Issue/getCompanyTasks",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/tasks`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
          },
          params: {
            // issue_id: id,
            is_company: 1,
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);
const IssueSlice = createSlice({
  name: "Issue",
  initialState: {
    isIssueLoading: false,
    error: null,
    CompanyUserArr: null,
    AgencyArr: null,
    CompanyUser_ID_Arr: null,
    IssueInfo: null,
    AllOpponentsArray: null,
    issueManagementArray: null,
    issueDocumentsArray: null,
    issueTasksArray: null,
    ImplementationIssueArray: null,
    SessionsIssueArray: null,
    CompanyTasksArray: null,
    AllComapnyIssueArray: null,
  },

  extraReducers: {
    [getCompanyUser.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getCompanyUser.fulfilled]: (state, action) => {
      state.CompanyUserArr = action.payload.data;
      state.isIssueLoading = false;
    },
    [getCompanyUser.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // getCompanyUser_id
    [getCompanyUser_id.pending]: (state, action) => {
      state.isIssueLoading = true;
      state.CompanyUser_ID_Arr = null;
    },
    [getCompanyUser_id.fulfilled]: (state, action) => {
      state.CompanyUser_ID_Arr = action.payload.data;
      state.isIssueLoading = false;
    },
    [getCompanyUser_id.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // AddCompanyUser
    [AddCompanyUser.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddCompanyUser.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [AddCompanyUser.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateCompanyUser
    [updateCompanyUser.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateCompanyUser.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateCompanyUser.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // deleteCompanyUser
    [deleteCompanyUser.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [deleteCompanyUser.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [deleteCompanyUser.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // getAgency
    [getAgency.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getAgency.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AgencyArr = action.payload.data;
    },
    [getAgency.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // AddAgency
    [AddAgency.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddAgency.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.AgencyArr) {
        state.AgencyArr.push(action.payload.data);
      }
    },
    [AddAgency.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateAgency
    [updateAgency.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateAgency.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      // state.AgencyArr = state.AgencyArr.map(
      //   (obj) => [action.payload.data].find((o) => o.id === obj.id) || obj
      // );
      // state.AgencyArr.push(action.payload.data);
    },
    [updateAgency.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // deleteAgency
    [deleteAgency.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [deleteAgency.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AgencyArr = state.AgencyArr.filter(
        (ele) => ele.id !== action.meta.arg
      );
      // state.AgencyArr.push(action.payload.data);
    },
    [deleteAgency.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddIssue
    [AddIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      // state.AgencyArr.push(action.payload.data);
    },
    [AddIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // GetIssue
    [GetIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [GetIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.IssueInfo = action.payload.data;
    },
    [GetIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // UpdateIssue
    [UpdateIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [UpdateIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [UpdateIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteIssue
    [DeleteIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.CompanyUser_ID_Arr.issues = state.CompanyUser_ID_Arr?.issues.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // GetAllOpponents
    [GetAllOpponents.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [GetAllOpponents.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AllOpponentsArray = action.payload.data;
    },
    [GetAllOpponents.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // AddIssueOpponents
    [AddIssueOpponents.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddIssueOpponents.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.AllOpponentsArray) {
        state.AllOpponentsArray.push(action.payload.data);
      }
    },
    [AddIssueOpponents.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // UpdateIssueOpponents
    [UpdateIssueOpponents.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [UpdateIssueOpponents.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [UpdateIssueOpponents.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteIssueOpponents
    [DeleteIssueOpponents.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteIssueOpponents.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AllOpponentsArray = state.AllOpponentsArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteIssueOpponents.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // GetAllComapnyIssue
    [GetAllComapnyIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [GetAllComapnyIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AllComapnyIssueArray = action.payload.data;
    },
    [GetAllComapnyIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // AddAllComapnyIssue
    [AddAllComapnyIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddAllComapnyIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.AllComapnyIssueArray) {
        state.AllComapnyIssueArray.push(action.payload.data);
      }
    },
    [AddAllComapnyIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // UpdateAllComapnyIssue
    [UpdateAllComapnyIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [UpdateAllComapnyIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [UpdateAllComapnyIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteAllComapnyIssue
    [DeleteAllComapnyIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteAllComapnyIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.AllComapnyIssueArray = state.AllComapnyIssueArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteAllComapnyIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // getIssueManagement
    [getIssueManagement.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getIssueManagement.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueManagementArray = action.payload.data;
    },
    [getIssueManagement.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // AddIssueManagement
    [AddIssueManagement.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddIssueManagement.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.issueManagementArray) {
        state.issueManagementArray.push(action.payload.data);
      }
    },
    [AddIssueManagement.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateIssueManagement
    [updateIssueManagement.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateIssueManagement.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateIssueManagement.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteIssueManagement
    [DeleteIssueManagement.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteIssueManagement.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueManagementArray = state.issueManagementArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteIssueManagement.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // getIssueDocument
    [getIssueDocument.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getIssueDocument.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueDocumentsArray = action.payload.data;
    },
    [getIssueDocument.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddIssueDocument
    [AddIssueDocument.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddIssueDocument.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.issueDocumentsArray) {
        state.issueDocumentsArray.push(action.payload.data);
      }
    },
    [AddIssueDocument.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateIssueDocument
    [updateIssueDocument.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateIssueDocument.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateIssueDocument.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteIssueDocument
    [DeleteIssueDocument.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteIssueDocument.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueDocumentsArray = state.issueDocumentsArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteIssueDocument.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // getIssueTasks
    [getIssueTasks.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getIssueTasks.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueTasksArray = action.payload.data;
    },
    [getIssueTasks.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddIssueDocument
    [AddIssueTasks.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddIssueTasks.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.issueTasksArray) {
        state.issueTasksArray.push(action.payload.data);
      }
    },
    [AddIssueTasks.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateIssueTasks
    [updateIssueTasks.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateIssueTasks.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateIssueTasks.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteIssueTasks
    [DeleteIssueTasks.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteIssueTasks.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.issueTasksArray = state.issueTasksArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteIssueTasks.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // getImplementationIssue
    [getImplementationIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getImplementationIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.ImplementationIssueArray = action.payload.data;
    },
    [getImplementationIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddImplementationIssue
    [AddImplementationIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddImplementationIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.ImplementationIssueArray) {
        state.ImplementationIssueArray.push(action.payload.data);
      }
    },
    [AddImplementationIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateImplementationIssue
    [updateImplementationIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateImplementationIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateImplementationIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteImplementationIssue
    [DeleteImplementationIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteImplementationIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.ImplementationIssueArray = state.ImplementationIssueArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteImplementationIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddCreateVerdict
    [AddCreateVerdict.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddCreateVerdict.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [AddCreateVerdict.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // getSessionsIssue
    [getSessionsIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getSessionsIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.SessionsIssueArray = action.payload.data;
    },
    [getSessionsIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },

    // AddSessionsIssue
    [AddSessionsIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [AddSessionsIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      if (state.SessionsIssueArray) {
        state.SessionsIssueArray.push(action.payload.data);
      }
    },
    [AddSessionsIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // updateSessionsIssue
    [updateSessionsIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [updateSessionsIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
    },
    [updateSessionsIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // DeleteSessionsIssue
    [DeleteSessionsIssue.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [DeleteSessionsIssue.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.SessionsIssueArray = state.SessionsIssueArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteSessionsIssue.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
    // getCompanyTasks
    [getCompanyTasks.pending]: (state, action) => {
      state.isIssueLoading = true;
    },
    [getCompanyTasks.fulfilled]: (state, action) => {
      state.isIssueLoading = false;
      state.CompanyTasksArray = action.payload.data;
    },
    [getCompanyTasks.rejected]: (state, action) => {
      state.isIssueLoading = false;
    },
  },
});

export default IssueSlice.reducer;
